import { Component } from '@angular/core';
import { ControlBase } from '../../../base/control-base/control-base.component';
import { News, NewsListControl } from 'angular-core-src';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'news-count',
    templateUrl: 'news-count.control.html',
    styleUrl: './news-count.control.scss',
    standalone: false,
})
export class NewsCountControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    public ngOnInit(): void {
        this.init();
        this.ioc.core.eventHandler.on(NewsListControl.NEWS_READ_CHANGED_EVENT, (): void => {
            this.setNewsCount();
        });
    }

    private setNewsCount() {
        let newsCount: number = this.settings.newsList.filter(x => !x.isRead).length;

        let el = document.querySelector<HTMLElement>('.notification');
        el.setAttribute('data-count', newsCount.toString());

        if (newsCount > 0) {
            el.classList.add('notify');
            el.classList.add('show-count');
        } else {
            el.classList.remove('show-count');
        }
    }

    private init(): void {
        let newsApiUrl = new URL(
            'api/news/',
            this.ioc.core.websiteConstants.applicationWebsite.FULL_MAIN_DOMAIN_URL
        ).toString();
        let baseUrl = newsApiUrl;
        let queryString: string = 'GetAllNews';
        let query: string = baseUrl + queryString;
        let newsListFromServerSide: News[] = [];
        $.get(query, (data: any): void => {
            $.each(data, (index, item) => {
                newsListFromServerSide.push(new News(item));
            });
        }).then(() => {
            if (!this.settings.newsList) {
                this.settings.newsList = newsListFromServerSide;
            } else {
                this.updateExistingNewsList_With_NewServerSideNews(newsListFromServerSide);
            }
            this.settings.updateSettingsInStorage();
            this.setNewsCount();
        });
    }

    private updateExistingNewsList_With_NewServerSideNews(newsListFromServerSide: News[]) {
        for (let i = 0; i < newsListFromServerSide.length; i++) {
            let newsFromSeverSide: News = newsListFromServerSide[i];
            let existingNews = this.settings.newsList.find(x => x.guid === newsFromSeverSide.guid);

            if (!existingNews) {
                this.settings.newsList.insert(0, newsFromSeverSide);
            }
        }
    }
}
